(function () {
  if (!window.matchMedia('(min-width: 990px)').matches) return;

  const product = document.querySelector('.product--large');
  if (!product) return;

  const infoContainer = product.querySelector('.product__info-container');

  const titleEl = product.querySelector('.product__title h1');
  const priceEl = product.querySelector('.price-item--regular');
  const mainBtn = product.querySelector('[name="add"]');

  const title = titleEl ? titleEl.textContent.trim() : '';
  const price = priceEl ? priceEl.textContent.trim() : '';
  const btnText = mainBtn ? mainBtn.textContent.replace(/\s+/g, ' ').trim() : 'Ajouter au panier';

  const reminder = document.createElement('div');
  reminder.className = 'product-reminder';
  reminder.setAttribute('aria-hidden', 'true');
  reminder.setAttribute('role', 'complementary');

  const infoRow = document.createElement('div');
  infoRow.className = 'product-reminder__info';

  const titleSpan = document.createElement('span');
  titleSpan.className = 'product-reminder__title';
  titleSpan.textContent = title;

  const priceSpan = document.createElement('span');
  priceSpan.className = 'product-reminder__price';
  priceSpan.textContent = price;

  infoRow.appendChild(titleSpan);

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'product-reminder__btn button button--primary';
  btn.textContent = btnText;
  btn.addEventListener('click', function () {
    if (mainBtn) mainBtn.click();
  });

  const rightGroup = document.createElement('div');
  rightGroup.className = 'product-reminder__right';
  rightGroup.appendChild(priceSpan);
  rightGroup.appendChild(btn);

  const headerEl = document.querySelector('.section-header');

  // Injecte les custom properties du color-scheme dans le reminder
  const schemeContext = product.querySelector('.product__info-container');
  if (schemeContext) {
    const ctx = getComputedStyle(schemeContext);
    const colorBtn = ctx.getPropertyValue('--color-button').trim();
    const colorBtnText = ctx.getPropertyValue('--color-button-text').trim();
    const colorFg = ctx.getPropertyValue('--color-foreground').trim();
    if (colorBtn) reminder.style.setProperty('--color-button', colorBtn);
    if (colorBtnText) reminder.style.setProperty('--color-button-text', colorBtnText);
    if (colorFg) reminder.style.setProperty('--color-foreground', colorFg);
  }

  reminder.appendChild(infoRow);
  reminder.appendChild(rightGroup);
  document.body.appendChild(reminder);

  if (!mainBtn) return;

  function getHeaderBottom() {
    const headerWrapper = document.querySelector('.header-wrapper');
    return (headerWrapper ? headerWrapper.offsetHeight : 47) - 1;
  }

  function updateReminderTop() {
    if (headerEl && headerEl.classList.contains('shopify-section-header-hidden')) {
      reminder.style.top = '0px';
    } else {
      reminder.style.top = getHeaderBottom() + 'px';
    }
  }

  const observer = new IntersectionObserver(function (entries) {
    const entry = entries[0];
    const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    if (visible && !reminder.classList.contains('product-reminder--visible')) {
      updateReminderTop();
    }
    reminder.classList.toggle('product-reminder--visible', visible);
    reminder.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }, { threshold: 0, rootMargin: '0px' });

  observer.observe(mainBtn);

  if (headerEl) {
    new MutationObserver(function() {
      updateReminderTop();
    }).observe(headerEl, { attributes: true, attributeFilter: ['class'] });
  }
})();
